import { useQuery } from '@tanstack/react-query'

import { listNotifications } from '@/client'

/**
 * The caller's notifications — `GET /v1/notifications`, the bell's feed.
 *
 * Read off the server's event log: somebody assigned you a ticket, commented
 * on one you raised or own, or mentioned you. Polled, as VentaHub fell back
 * to polling when its stream was down: a minute is fresh enough for a nudge,
 * and only while the tab is visible, so a background tab costs nothing.
 * Focusing the tab again asks at once.
 */
export const notificationKeys = {
  all: ['notifications'] as const,
  list: () => [...notificationKeys.all, 'list'] as const,
}

/** How often an open, visible tab asks for new notifications. */
export const NOTIFICATIONS_POLL_MS = 60_000

export function useNotifications() {
  return useQuery({
    queryKey: notificationKeys.list(),
    queryFn: async () => (await listNotifications({ throwOnError: true })).data,
    refetchInterval: NOTIFICATIONS_POLL_MS,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: true,
    staleTime: 30_000,
  })
}
